import { AxiosRequestConfig, AxiosResponse } from 'axios';

export const FETCH_VACANCY = 'FETCH_VACANCY_ANNONYMOUS';
export const FETCH_VACANCY_SUCCESS = 'FETCH_VACANCY_ANNONYMOUS_SUCCESS';

export type VacancyAction = FetchVacancySuccess;

export interface FetchVacancyAction {
    type: typeof FETCH_VACANCY;
    payload: {
        request: AxiosRequestConfig;
    };
}

export interface FetchVacancySuccess {
    type: typeof FETCH_VACANCY_SUCCESS;
    payload: AxiosResponse;
}

export const fetchVacancy = (vacancyId: string): FetchVacancyAction => {
    const fetchApplicationAction: FetchVacancyAction = {
        type: FETCH_VACANCY,
        payload: {
            request: {
                url: `/candidates/vacancies/${vacancyId}`,
            },
        },
    };
    return fetchApplicationAction;
};



// WEBPACK FOOTER //
// ./src/scenes/vacancy/actions.ts